export default __webpack_public_path__ + "static/media/A4HPOSTER.7c2ef476.png";